import { Box } from '@chakra-ui/react';
import type { BoxProps } from '@chakra-ui/react';
import type { ReactElement } from 'react';
import VMaterialIcon from '@voly/ui-components/src/v2/icons/VMaterialIcon.jsx';

const LOCK_ICON_SIZE = '16px';

const FieldLockedIcon = (props: BoxProps): ReactElement => (
  <Box as="span" data-testid="field-locked-icon" color="fg.subtle" display="flex" {...props}>
    <VMaterialIcon name="lock" size={LOCK_ICON_SIZE} />
  </Box>
);

export default FieldLockedIcon;
